import React, { useState, useEffect, useRef } from 'react';
import HongButton from '../comm/HongButton';
import fnc from '../mymod/commFunction';
import './StoreBookMain.scss';
import { useNavigate } from 'react-router-dom';

const StoreBookMain = ({ 
  bookCategories,
  selectedMenu, 
  selectedChildCode, 
  onShowInsert
}) => {

  const navigate = useNavigate();
  const [bookList, setBookList] = useState([]);
  const [isLoadingBooks, setIsLoadingBooks] = useState(false);
  const [imageErrors, setImageErrors] = useState({});
  const prevChildCodeRef = useRef(null);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedGrade, setSelectedGrade] = useState('');
  const [selectedPublisher, setSelectedPublisher] = useState('');
  const [gradeOptions, setGradeOptions] = useState([]);
  const [publisherOptions, setPublisherOptions] = useState([]);
  const [searchAppliedKeyword, setSearchAppliedKeyword] = useState('');
  const [searchAppliedGrade, setSearchAppliedGrade] = useState('');
  const [searchAppliedPublisher, setSearchAppliedPublisher] = useState('');
  const [isAllBooksView, setIsAllBooksView] = useState(false);


  const S3_BASE_URL = 'https://kuesb2.s3.ap-northeast-2.amazonaws.com/public/storeBook/';

  useEffect(() => {
    fnc.sendAxios('/storeBookRoutes/select/storeBookList/filters', {}, (res) => {
      setGradeOptions((res?.grades || []).map((item) => item.grade).filter(Boolean));
      setPublisherOptions((res?.publishers || []).map((item) => item.publisher).filter(Boolean));
    });
  }, []);

  useEffect(() => {
    const hasIntegratedCriteria = Boolean(
      searchAppliedKeyword || searchAppliedGrade || searchAppliedPublisher || isAllBooksView
    );

    // 선택된 메뉴가 변경될 때 교재 목록 로드
    if (!hasIntegratedCriteria && selectedChildCode && selectedChildCode !== prevChildCodeRef.current) {
      prevChildCodeRef.current = selectedChildCode;
      setIsAllBooksView(false);
      loadBookList(selectedChildCode);
    }
  }, [selectedChildCode, searchAppliedKeyword, searchAppliedGrade, searchAppliedPublisher, isAllBooksView]);

  const loadBookList = (childCode) => {
    if (!childCode) {
      setBookList([]);
      return;
    }
    
    setIsLoadingBooks(true);
    setImageErrors({});

    fnc.sendAxios('/storeBookRoutes/select/storeBookList/detail', { pCode: childCode }, (res) => {
      if (res && res.length > 0) {
        setBookList(res);
      } else {
        setBookList([]);
      }
      setIsLoadingBooks(false);
    });
  };

  const loadIntegratedSearchList = (keyword, grade, publisher) => {
    setIsLoadingBooks(true);
    setImageErrors({});

    fnc.sendAxios('/storeBookRoutes/select/storeBookList/search', { keyword, grade, publisher }, (res) => {
      if (res && res.length > 0) {
        setBookList(res);
      } else {
        setBookList([]);
      }
      setIsLoadingBooks(false);
    });
  };

  const executeSearch = (keyword, grade, publisher) => {
    const trimmedKeyword = keyword.trim();
    const hasAnyCriteria = Boolean(trimmedKeyword || grade || publisher);

    setSearchAppliedKeyword(trimmedKeyword);
    setSearchAppliedGrade(grade);
    setSearchAppliedPublisher(publisher);

    if (!hasAnyCriteria) {
      setIsAllBooksView(true);
      loadIntegratedSearchList('', '', '');
      return;
    }

    setIsAllBooksView(false);
    loadIntegratedSearchList(trimmedKeyword, grade, publisher);
  };

  const handleSearch = () => {
    executeSearch(searchKeyword, selectedGrade, selectedPublisher);
  };

  const handleGradeChange = (e) => {
    const nextGrade = e.target.value;
    setSelectedGrade(nextGrade);
    executeSearch(searchKeyword, nextGrade, selectedPublisher);
  };

  const handlePublisherChange = (e) => {
    const nextPublisher = e.target.value;
    setSelectedPublisher(nextPublisher);
    executeSearch(searchKeyword, selectedGrade, nextPublisher);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const onOnlineLearning = (book) => {

    fncGetBookCodeList(book.kuesbBookCode);

  };

  function fncGetBookCodeList(kuesbBookCode) {
    fnc.sendAxios('/storeBookRoutes/select/bookCodeList', { kuesbBookCode }, (res) => {

        if (res && res.length > 0) {
          res.forEach(item => {
            fnc.setCookie_pure(`unit${item.LevelDepth + 1}_exam`, item.childKey);
            console.log(`unit_${item.LevelDepth + 1}`, item.childKey);
          });
        } else {
          alert('교재 코드가 없습니다.'); 
        }

        const rtn = window.confirm(`온라인 학습을 하시겠습니까?`);
        if (!rtn) return;
        navigate('/exam');
    });



  };
  

  
    function onNiceOrder(book) {
      const certCode = fnc.getCookie('certCode');
      const id = fnc.getCookie('id');
      const stCode = fnc.getCookie('stCode');
      const userName = fnc.getCookie('userName');
      const email = fnc.getCookie('email');
      const productCode = book.kuesbBookCode;
  
      const kind = '진단평가';
      const price = book.price;
      const acaDbName = 'kuesbLms2000';

      const rtn = window.confirm(`${book.title} 교재를 구매하시겠습니까?`);
      if (!rtn) {
        return;
      }

      if (Number(price) === 0) {
        alert('가격정보가 없습니다!');
        return;
      }
        
      if (productCode) {
          openOrderWindow();
      } else {
        alert('교재코드가 등록이 안되었습니다.');
      }
    
    
  

      function openOrderWindow() {
        const query = new URLSearchParams({
          certCode,
          id,
          stCode,
          userName,
          email,
          productCode,
          kind,
          acaDbName
        }).toString(); 
    
        const url = `https://kuebs.com/tossPayDirect?${query}`;
        // const url = `http://localhost:3002/tossPayDirect?${query}`;
        // const url = `${nicePayUrl}/tossPayDirect?${query}`;
        window.open(url, '_blank');

    }

  }


  const handleImageError = (bookCode) => {
    setImageErrors(prev => ({
      ...prev,
      [bookCode]: true
    }));
  };

  const selectedCategory = bookCategories.find(cat => cat.parent_code === selectedMenu);
  const selectedChild = selectedCategory?.children.find(child => child.child_code === selectedChildCode);
  const categoryTitle = `${selectedCategory?.parent_unit || ''}${selectedChild ? ` - ${selectedChild.child_unit}` : ''}`;
  const isIntegratedView = Boolean(
    searchAppliedKeyword || searchAppliedGrade || searchAppliedPublisher || isAllBooksView
  );

  //============================================================================================
  return (
    <main className="store-main">
      <div className="main-header">
        <div className="main-header-left">
          <h2 className="main-title">
            통합검색
          </h2>

          <div className="integrated-search">
            <select
              value={selectedGrade}
              onChange={handleGradeChange}
            >
              <option value="">학년 전체</option>
              {gradeOptions.map((grade) => (
                <option key={grade} value={grade}>{grade}</option>
              ))}
            </select>

            <select
              value={selectedPublisher}
              onChange={handlePublisherChange}
            >
              <option value="">출판사 전체</option>
              {publisherOptions.map((publisher) => (
                <option key={publisher} value={publisher}>{publisher}</option>
              ))}
            </select>

            <input
              type="text"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              onKeyDown={handleSearchKeyDown}
              placeholder="통합검색"
            />
            <HongButton
              className='btn h-btn-dark'
              onClick={handleSearch}
            >
              검색
            </HongButton>
          </div>
        </div>

        <HongButton
            className='btn h-btn-dark'
            iconType={'write'}
            onClick={onShowInsert}
            >
            교재 관리
        </HongButton>
      </div>
      
      <div className="main-content">
        {isLoadingBooks ? (
          <div className="loading-message">
            <p>교재 목록을 불러오는 중...</p>
          </div>
        ) : bookList.length === 0 ? (
          <div className="empty-message">
            <p>교재가 없습니다.</p>
          </div>
        ) : (
          <div className="book-list">
            {bookList.map((book) => {
              const imageKey = `${book.pCode || 'all'}-${book.code}-${book.sno || ''}`;

              return (
              <div key={`${book.pCode || 'all'}-${book.code}-${book.sno || ''}`} className="book-card">
                <div className="book-image">
                  {book.imgFileName2 && !imageErrors[imageKey] ? (
                    <img 
                      src={S3_BASE_URL + book.imgFileName2} 
                      alt={book.title}
                      loading="lazy"
                      onError={() => handleImageError(imageKey)}
                    />
                  ) : (
                    <div className="no-image-placeholder">
                      <div>이미지 없음</div>
                    </div>
                  )}
                </div>
                <div className="book-info">
                  <p className="book-title">{book.grade} {book.title}</p>
                  {isIntegratedView && (
                    <p className="book-category">{book.parentUnit} {book.childUnit ? `> ${book.childUnit}` : ''}</p>
                  )}
                  <p className="book-content">{book.content}</p>
                  <p className="book-publisher">{book.publisher}</p>
                  <p className="book-price">{Number(book.price).toLocaleString()}원</p>

                  <div className='box-btn'>
                    <HongButton
                      className='btn h-btn-white'
                      onClick={() => onNiceOrder(book)}
                    >
                      구매하기
                    </HongButton>

                    <HongButton
                      className='btn h-btn-white'
                      onClick={() => onOnlineLearning(book)}
                    >
                      온라인학습
                    </HongButton>
                  </div>
                </div>
              </div>
              );
            })}
          </div>
        )}
      </div>
    </main>
  );
};

export default StoreBookMain;
